import React, { useState, useContext, useEffect } from "react";
import { useDeepEffect, useRouterParams } from "../../abstracts";
import { Link } from "react-router-dom";
import { Button, Form } from "react-bootstrap";
import {
  SliderPanel,
  FieldInput,
  FieldTextarea,
  FieldButtonGroup,
  FormLeaveGuard,
  DatePicker,
  FieldDropSide,
  MultiSelectDropdown,
  FieldInputNumber,
  FieldInputDecimal,
  LoaderWrapper,
} from "../../components";
import "../../styles/components/CensusVestingCard.scss";
//import { manageCensusStore } from "../../contexts";
import {
  manageCensusFormNames,
  formFields,
  yesNoOptions,
  usDateFormat,
  toMultiSelectValueById,
  clearFieldValues,
} from "../../utils";
import { Formik, Field } from "formik";
import { first, get, isEmpty } from "lodash";
import { EmployeeVestingHistoryTimeline } from "../../components";
import {
  postSaveVestingConfigurationForSource,
  postEmployeeVestingHistoryDetails,
} from "../../services";
import VestingOverrideToggle from "../VestingOverrideToggle";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { ColumnMenu } from "../../containers/ReportsContainer/PeriodicCensus/columnMenu";

const initialValues = {};
const labelOptions = [
  { label: "Computation Period", value: 1 },
  { label: "Credited This Year", value: 2 },
  { label: "Vesting Override", value: 3 },
  // { label: "Vesting Multiplier", value: 4 },
  { label: "Vesting Percentage", value: 5 },
  //{ label: "VestingPercentageMetDate", value: 6 },
  { label: "Years Of Service", value: 6 },
  { label: "Comments", value: 7 },
];

const data1 = [
  [
    {
      fieldEdited: "Vesting YOS",
      previousValue: "2",
      updatedValue: "NA",
      comment: "Added through file AC",
    },
    {
      fieldEdited: "Vesting Percentage",
      previousValue: "70",
      updatedValue: "100",
      comment: "Added through file AC",
    },
  ],
  {
    fieldEdited: "Vesting YOS",
    previousValue: "1",
    updatedValue: "2",
    comment: "Added through file AC",
  },
];
const tempVestingHistoryDetails = [
  {
    vestingYOS: 12,
    creditedThisComputationPeriod: false,
    vestingComputationPeriod: 4,
    vestingPercentage: 40,
    vestingOverride: false,
    vestedBalance: 23,
    comments: "Yes",
    startDate: "2023-06-01T05:30:00Z",
    endDate: "2023-06-30T05:30:00Z",
    runDate: "05/15/2023",
  },
  {
    vestingYOS: 5,
    creditedThisComputationPeriod: true,
    vestingComputationPeriod: 2,
    vestingPercentage: 20,
    vestingOverride: false,
    vestedBalance: 15,
    comments: "Win",
    startDate: "2023-06-01T05:30:00Z",
    endDate: "2023-06-30T05:30:00Z",
    runDate: "05/15/2023",
  },
  {
    vestingYOS: 3,
    creditedThisComputationPeriod: false,
    vestingComputationPeriod: 1,
    vestingPercentage: 15,
    vestingOverride: true,
    vestedBalance: 23,
    comments: "Yes",
    startDate: "2023-07-01T05:30:00Z",
    endDate: "2023-07-30T05:30:00Z",
    runDate: "05/15/2023",
  },
  {
    vestingYOS: 6,
    creditedThisComputationPeriod: false,
    vestingComputationPeriod: 4,
    vestingPercentage: 40,
    vestingOverride: false,
    vestedBalance: 23,
    comments: "Yes",
    startDate: "2023-04-01T05:30:00Z",
    endDate: "2023-04-30T05:30:00Z",
    runDate: "05/11/2023",
  },
  {
    vestingYOS: 3,
    creditedThisComputationPeriod: true,
    vestingComputationPeriod: 2,
    vestingPercentage: 20,
    vestingOverride: true,
    vestedBalance: 25,
    comments: "Win",
    startDate: "2023-04-01T05:30:00Z",
    endDate: "2023-04-30T05:30:00Z",
    runDate: "05/11/2023",
  },
  {
    vestingYOS: 3,
    creditedThisComputationPeriod: false,
    vestingComputationPeriod: 1,
    vestingPercentage: 15,
    vestingOverride: true,
    vestedBalance: 23,
    comments: "Yes",
    startDate: "2023-04-01T05:30:00Z",
    endDate: "2023-04-30T05:30:00Z",
    runDate: "05/11/2023",
  },
  {
    vestingYOS: 5,
    creditedThisComputationPeriod: true,
    vestingComputationPeriod: 2,
    vestingPercentage: 30,
    vestingOverride: true,
    vestedBalance: 23,
    comments: "Yes",
    startDate: "2023-04-01T05:30:00Z",
    endDate: "2023-04-30T05:30:00Z",
    runDate: "05/10/2023",
  },
  {
    vestingYOS: 3,
    creditedThisComputationPeriod: true,
    vestingComputationPeriod: 2,
    vestingPercentage: 20,
    vestingOverride: true,
    vestedBalance: 23,
    comments: "Yes",
    startDate: "2023-04-01T05:30:00Z",
    endDate: "2023-04-30T05:30:00Z",
    runDate: "05/10/2023",
  },
];

const columns = [
  {
    value: 1,
    label: "Vesting YOS",
    className: "column-vestingYOS",
    columnName: "vestingYOS",
    field: "vestingYOS",
    width: 111,
    dataType: "alphaNumeric",
    field1: "vestingYOS",
  },
  {
    value: 2,
    label: "Credited This Computation Period",
    className: "column-creditedThisComputationPeriod",
    columnName: "creditedThisYear",
    field: "creditedThisYear",
    width: 111,
    dataType: "alphaNumeric",
    field1: "creditedThisYear",
  },
  {
    value: 3,
    label: "Computation Period",
    className: "column-computationPeriod",
    columnName: "computationPeriod",
    field: "computationPeriod",
    width: 210,
    dataType: "alphaNumeric",
    field1: "computationPeriod",
  },
  {
    value: 4,
    label: "Vesting Percentage",
    className: "column-vestingPercentage",
    columnName: "vestingPercentage",
    field: "vestingPercentage",
    width: 149,
    dataType: "alphaNumeric",
    field1: "vestingPercentage",
  },
  {
    value: 5,
    label: "Vesting Override",
    className: "column-vestingOverride",
    columnName: "vestingOverride",
    field: "vestingOverride",
    width: 149,
    dataType: "alphaNumeric",
    field1: "vestingOverride",
  },
  {
    value: 6,
    label: "Vested Balance",
    className: "column-vestedBalance",
    columnName: "vestedBalance",
    field: "vestedBalance",
    width: 135,
    dataType: "alphaNumeric",
    field1: "vestedBalance",
  },
  {
    value: 7,
    label: "Comments",
    className: "column-comments",
    columnName: "comments",
    field: "comments",
    width: 195,
    dataType: "alphaNumeric",
    field1: "comments",
  },
  // {
  //   value: 8,
  //   label: "Vesting Computation Period",
  //   className: "column-vestingComputationPeriod",
  //   columnName: "vestingComputationPeriod",
  //   field: "vestingComputationPeriod",
  //   width: 144,
  //   dataType: "alphaNumeric",
  //   field1: "vestingComputationPeriod",
  // },
];

const CensusVestingCard = ({
  data,
  toggle,
  setToggle,
  setFieldError,
  BISType,
}) => {
  const formName = manageCensusFormNames.CENSUS_VESTING;
  const fields = formFields[formName];
  const { planId } = useRouterParams();
  //const intPlanId = parseInt(planId, 10);
  const { censusId } = useRouterParams();
  //const intEmployeeId = parseInt(censusId, 10);
  const [sliderOpen, setSliderOpen] = useState(false);
  const [historySliderOpen, setHistorySliderOpen] = useState(false);
  const [isInnerFormDirty, setIsInnerFormDirty] = useState(false);
  const [showDirtyCheckModal, setShowDirtyCheckModal] = useState(false);
  const [lastScrollTop, setLastScrollTop] = useState(null);
  const [onClickSave, setOnClickSave] = useState(false);
  const [sorting, setSorting] = useState();
  const [runDateValue, setRunDateValue] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [final, setFinal] = useState(columns);
  const [
    employeeVestingHistoryDetails,
    setEmployeeVestingHistoryDetails,
  ] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchData, setSearchData] = useState();
  const [selectedColumns, setSelectedColumns] = useState([
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    // 8,
  ]);

  const vestingLabels = [
    { label: "Source", columnName: "sourceName" },
    {
      label: "Source Balance",
      columnName: "sourceBalance",
    },
    {
      label: "Vesting percentage",
      columnName: "vestingPercentage",
    },
    { label: "Vesting override", columnName: "vestingOverride" },
    {
      label: "Vested balance",
      columnName: "vestedBalance",
    },
  ];
  const vestingLabels2 = [
    { label: "Vesting YOS", columnName: "vestingYOS" },
    { label: "Computation period", columnName: "computationStartDate" },
    {
      label: "Credited this computation period",
      columnName: "creditedThisYear",
    },
    { label: "", columnName: "computationButtons" },
  ];
  const sliderLabel = [
    { label: "Source name", columnName: "sourceName" },
    //{ label: "Vesting schedule", columnName: "vestingSchedule" },
    // {
    //   label: "Vesting percentage",
    //   columnName: "vestingPercentage",
    // },
    { label: "Computation period", columnName: "computationStartDate" },
  ];
  useEffect(() => {
    return () => setIsInnerFormDirty(false);
  }, []);
  const onFormToggle = () => {
    if (isInnerFormDirty) {
      setShowDirtyCheckModal(true);
    } else {
      setSliderOpen(false);
    }
  };
  const onFormToggleSave = () => {
    setShowDirtyCheckModal(true);
    //setSliderOpen(false);
  };
  const handleConfirmClick = () => {
    setSliderOpen(false);
  };

  const handleCancelClick = () => {
    setShowDirtyCheckModal(false);
  };

  const renderValue = (value) => {
    var tempVal = value;
    value = value?.dataItem ? value.dataItem[value.field] : value;
    const index = tempVal.dataItem["newIndex"];
    var comparedValue;
    if (employeeVestingHistoryDetails.length > index + 1) {
      if (tempVal.dataIndex < employeeVestingHistoryDetails[index + 1].length) {
        comparedValue =
          employeeVestingHistoryDetails[index + 1][tempVal.dataIndex][
            tempVal.field
          ];
      } else {
        comparedValue = tempVal.dataItem[tempVal.field];
      }
    } else {
      comparedValue = tempVal.dataItem[tempVal.field];
    }
    var status = tempVal.dataItem[tempVal] !== comparedValue;
    if (status) {
      return (
        <td style={{ color: "#000000" }}>
          {value || value === 0 ? (
            <div style={{ color: "#000000" }}>{value}</div>
          ) : (
            <div>NA</div>
          )}
        </td>
      );
    } else {
      return (
        <td>{value || value === 0 ? <div>{value}</div> : <div>NA</div>}</td>
      );
    }
    //return <td>{value || value === 0 ? <div>{value}</div> : <div> -</div>}</td>;
  };
  const filterByDates = (fd, td) => {
    var filtered;
    if (fd && td) {
      filtered = employeeVestingHistoryDetails.filter(
        (items) =>
          usDateFormat(items[0].runDate) > fd &&
          usDateFormat(items[0].runDate) < td
      );
    } else if (fd != null && td == null) {
      filtered = employeeVestingHistoryDetails.filter(
        (items) => usDateFormat(items[0].runDate) > fd
      );
    } else if (td != null && fd == null) {
      filtered = employeeVestingHistoryDetails.filter(
        (items) => usDateFormat(items[0].runDate) < td
      );
    } else {
      filtered = employeeVestingHistoryDetails;
    }
    setFilteredData(filtered);
  };

  const separateArrayByValue = (arr, prop) => {
    var grouped = {};
    var runDate = [];
    arr.forEach(function (obj) {
      var value = obj[prop];
      runDate.push(obj[prop].replace("T", " ").replace("Z", ""));
      // delete obj[prop];
      if (!grouped[value]) {
        grouped[value] = [];
      }
      grouped[value].push(obj);
    });
    // setRunDateValue([...new Set(runDate)]);
    const sortedDates = runDate.sort((a, b) => {
      const dateA = new Date(a);
      const dateB = new Date(b);
      return dateB - dateA;
    });
    setRunDateValue([...new Set(sortedDates)]);
    return grouped;
  };

  const separateKeys = (separatedData) => {
    const rabbit = Object.keys(separatedData);
    const newrabbit = rabbit.sort((a, b) => {
      const dateA = new Date(a);
      const dateB = new Date(b);
      return dateB - dateA;
    });
    var finalHistoryDetails = [];
    for (var i = 0; i < newrabbit.length; i++) {
      finalHistoryDetails.push(separatedData[newrabbit[i]]);
    }
    for (var i = 0; i < finalHistoryDetails.length; i++) {
      for (var j = 0; j < finalHistoryDetails[i].length; j++) {
        finalHistoryDetails[i][j]["newIndex"] = i;
      }
    }
    return finalHistoryDetails;
  };

  const renderValueDate = (value) => {
    var tempVal = value;
    value = value?.dataItem ? value.dataItem[value.field] : value;
    const index = tempVal.dataItem["newIndex"];
    var comparedValue;
    if (employeeVestingHistoryDetails.length > index + 1) {
      if (tempVal.dataIndex < employeeVestingHistoryDetails[index + 1].length) {
        comparedValue =
          employeeVestingHistoryDetails[index + 1][tempVal.dataIndex][
            tempVal.field
          ];
      } else {
        comparedValue = tempVal.dataItem[tempVal.field];
      }
    } else {
      comparedValue = tempVal.dataItem[tempVal.field];
    }
    var status = tempVal.dataItem[tempVal.field] !== comparedValue;
    if (status) {
      return (
        <td style={{ color: "#000000" }}>
          {value || value === 0 ? (
            <div style={{ color: "#000000" }}>{usDateFormat(value)}</div>
          ) : (
            <div>NA</div>
          )}
        </td>
      );
    } else {
      return (
        <td>
          {value || value === 0 ? (
            <div>{usDateFormat(value)}</div>
          ) : (
            <div>-</div>
          )}
        </td>
      );
    }
  };
  const renderValueDateRange = (value) => {
    var startDate = value?.dataItem ? value.dataItem["startDate"] : value;
    var endDate = value?.dataItem ? value.dataItem["endDate"] : value;
    return (
      <td>
        {startDate && endDate ? (
          <div>{`${usDateFormat(startDate)} - ${usDateFormat(endDate)}`}</div>
        ) : (
          <div>NA</div>
        )}
      </td>
    );
  };
  const renderValueBoolean = (value) => {
    var tempVal = value;
    value = value?.dataItem ? value.dataItem[value.field] : value;
    const index = tempVal.dataItem["newIndex"];
    var comparedValue;
    if (employeeVestingHistoryDetails.length > index + 1) {
      if (tempVal.dataIndex < employeeVestingHistoryDetails[index + 1].length) {
        comparedValue =
          employeeVestingHistoryDetails[index + 1][tempVal.dataIndex][
            tempVal.field
          ];
      } else {
        comparedValue = tempVal.dataItem[tempVal.field];
      }
    } else {
      comparedValue = tempVal.dataItem[tempVal.field];
    }
    var status = tempVal.dataItem[tempVal.field] !== comparedValue;
    if (status) {
      return (
        <td style={{ color: "#000000" }}>
          {value ? (
            <div style={{ color: "#000000" }}>true</div>
          ) : (
            <div style={{ color: "#000000" }}> false</div>
          )}
        </td>
      );
    } else {
      return <td>{value ? <div>true</div> : <div> false</div>}</td>;
    }
  };

  const scrollHandler = (event) => {
    const e = event.nativeEvent;
    if (lastScrollTop === e.target.scrollTop) {
      return;
    }
    setLastScrollTop(e.target.scrollTop);
    if (
      e.target.scrollTop + 20 >=
      e.target.scrollHeight - e.target.clientHeight
    ) {
    }
  };
  class ProductNameHeader extends React.Component {
    render() {
      return (
        <a className="k-link" onClick={this.props.onClick}>
          <span title={this.props.title}>{this.props.title}</span>
          {this.props.children}
        </a>
      );
    }
  }

  const functionApiCall = (values, { setFieldError }) => {
    setIsLoading(true);
    // var separatedData = separateArrayByValue(tempVestingHistoryDetails,'runDate');
    // var finalHistoryDetails = separateKeys(separatedData);
    // setEmployeeVestingHistoryDetails(finalHistoryDetails);
    if (values.toDate < values.fromDate) {
      setFieldError(fields.toDate, "To date should be prior to From date");
      return;
    }
    postEmployeeVestingHistoryDetails(
      parseInt(censusId),
      parseInt(planId),
      parseInt(data.sourceId)
      // vestingFields: values.label,
      // fromDate: values.fromDate ? values.fromDate : null,
      // toDate: values.toDate ? values.toDate : null,
    )
      .then((response) => {
        setIsLoading(false);
        if (response) {
          var separatedData = separateArrayByValue(response, "runDate");
          var finalHistoryDetails = separateKeys(separatedData);
          setEmployeeVestingHistoryDetails(finalHistoryDetails);
          setFilteredData(finalHistoryDetails);
        } else {
        }
      })
      .catch((error) => {
        setIsLoading(false);
        //Handle Error
      });
  };
  const onFormSubmit = (values, { setFieldError }) => {
    postSaveVestingConfigurationForSource({
      ...values,
      vestingMultiplier: parseFloat(values[fields.vestingMultiplier], 10),
      vestingYOS: parseFloat(values[fields.vestingYOS], 10),
      vestingPercentage: parseFloat(values[fields.vestingPercentage], 10),
      vestedBalance: parseFloat(values[fields.vestedBalance], 10),
      id: data.id,
    })
      .then((response) => {
        if (response.isSuccessfull) {
          setToggle(!toggle);
          setSliderOpen(false);
          return true;
        } else {
          response.errorMessages.forEach((_) => {
            setFieldError(_.controlName, `${_.errorCode} : ${_.message}`);
            return false;
          });
          //setOnClickSave(false);
        }
      })
      .catch((error) => {
        //Handle Error
        setSliderOpen(true);
      });
  };

  const BISTypeMessage = () => {
    switch (BISType) {
      case 1:
        return "The Participant is on hold out period";
      case 2:
        return "The Participant has met Five year BIS criteria";
      case 3:
        return "The Participant has met Rule of Parity criteria";
    }
  };
  return (
    <>
      <div className="censusVestingCard">
        <div className="boxborder">
          {BISType > 0 && (
            <div className="BISType">
              <i
                class="fas fa-exclamation-triangle WarningTriangle"
                aria-hidden="true"
              ></i>
              <p className="BISTypeContent">{BISTypeMessage()}</p>
            </div>
          )}
          <div className="displaycontent">
            {vestingLabels.map((item, index) => {
              if (index == 0)
                return (
                  <div className="col-display">
                    <p className="label">{item.label}</p>
                    <p className="sourcename">{data[item.columnName]}</p>
                    {/* <div className="source-details">
                      <p className="label">{data.vestingSchedule}</p>
                      <hr class="percentage-separator"></hr>
                      <p className="label">
                        {parseFloat(data.vestingPercentage).toFixed(2)} %
                      </p>
                    </div> */}
                  </div>
                );
              else if (index == 1)
                return (
                  <div className="col-display">
                    <p className="label">{item.label}</p>
                    <p className="col-content">
                      {/* {parseFloat(data[item.columnName]).toFixed(4)} */}
                      {parseFloat(data[item.columnName])}
                    </p>
                  </div>
                );
              else if (index == 2)
                return (
                  <div className="col-display">
                    <p className="label">{item.label}</p>
                    <p className="col-content">
                      {parseFloat(data[item.columnName])} %
                    </p>
                  </div>
                );
              else if (index == 3)
                return (
                  <div className="col-display">
                    <p className="label">{item.label}</p>
                    <p className="col-content">
                      {data.vestingOverride ? "True" : "False"}
                    </p>
                  </div>
                );
              else
                return (
                  <div className="col-display">
                    <p className="label">{item.label}</p>
                    <p className="col-content">
                      {parseFloat(data[item.columnName]).toFixed(4)}
                    </p>
                  </div>
                );
            })}
          </div>
          <div className="line-separator"></div>
          <div className="displaycontent">
            {vestingLabels2.map((item, index) => {
              if (index == 3)
                return (
                  <div className="fl">
                    <Link
                      // to={getPathWithParam({
                      //   path: item.link,
                      //   pathParam: [flow, planId, source.id],
                      // })}
                      onClick={() => {
                        functionApiCall(
                          { fromDate: "", toDate: "", label: [] },
                          setFieldError
                        );
                        setHistorySliderOpen(true);
                      }}
                      className="link-style"
                    >
                      View History
                    </Link>
                    <div className="button-class">
                      <Button
                        type="button"
                        variant="secondary"
                        // disabled={data.vestingPercentage == 100 ? true : false}
                        onClick={() => {
                          setIsInnerFormDirty(false);
                          setShowDirtyCheckModal(false);
                          setSliderOpen(true);
                        }}
                      >
                        Edit
                      </Button>
                    </div>
                  </div>
                );
              else
                return (
                  <div className="col-display">
                    <p className="label">{item.label}</p>
                    <p className="col-bottomcontent">
                      {item.columnName === "vestingYOS" &&
                      data[item.columnName] != null
                        ? data[item.columnName] > 1
                          ? data[item.columnName] + " years"
                          : data[item.columnName] + " year"
                        : item.columnName === "creditedThisYear" &&
                          data[item.columnName] != null
                        ? data[item.columnName] == true
                          ? "Yes"
                          : "No"
                        : item.columnName === "computationStartDate" &&
                          data[item.columnName] != null
                        ? data[item.columnName]
                        : "NA"}
                    </p>
                  </div>
                );
            })}
          </div>
        </div>
      </div>
      <SliderPanel
        isOpen={sliderOpen}
        size="70"
        showCancel={false}
        backdropClicked={() => setSliderOpen(false)}
      >
        <Formik
          initialValues={{
            ...initialValues,
            [fields.creditedThisYear]: get(data, "creditedThisYear"),
            [fields.vestingMultiplier]: data.vestingMultiplier
              ? data.vestingMultiplier
              : null,
            [fields.vestingYOS]: data.vestingYOS ? data.vestingYOS : null,
            [fields.vestingPercentage]: data.vestingPercentage
              ? data.vestingPercentage
              : null,
            [fields.vestedBalance]: data.vestedBalance
              ? data.vestedBalance
              : null,
            [fields.vestingOverride]: data.vestingOverride,
            [fields.comments]: data.comments ? data.comments : null,
          }}
          //onSubmit={onFormSubmit}
          enableReinitialize
          validateOnChange={false}
          validateOnBlur={false}
        >
          {({
            handleChange,
            setFieldValue,
            handleSubmit,
            setValues,
            values,
            dirty,
            ...rest
          }) => {
            if (isInnerFormDirty !== dirty) {
              setIsInnerFormDirty(dirty);
            }
            const handleConfirmClickVar = () => {
              const status = onFormSubmit(values, { setFieldError });
              if (status) {
                setSliderOpen(false);
              } else {
                setSliderOpen(true);
                setShowDirtyCheckModal(false);
              }
            };
            const clearValuesSlider = () => {
              //    clearFieldValues({
              //       fieldsToClear: [fields.vestingYOS, fields.creditedThisYear,fields.vestingPercentage],
              // });
              if (values[fields.vestingOverride] !== false) {
                setFieldValue(fields.vestingYOS, "");
                setFieldValue(fields.vestingPercentage, "");
                setFieldValue(fields.creditedThisYear, "");
              } else {
                setFieldValue(fields.vestingYOS, data.vestingYOS);
                setFieldValue(fields.vestingPercentage, data.vestingPercentage);
                setFieldValue(fields.creditedThisYear, data.creditedThisYear);
              }
            };

            return (
              <Form
                autoComplete="off"
                className="h-100"
                onSubmit={handleSubmit}
                validated={!isEmpty(rest.errors)}
              >
                <div className="slider-header">
                  <div className="slider-sourcename">{data.sourceName}</div>
                  <div className="fl">
                    <div>
                      <Button
                        variant="secondary"
                        onClick={() => {
                          onFormToggle();
                          setOnClickSave(false);
                        }}
                      >
                        Cancel
                      </Button>
                    </div>
                    <div className="ml-15">
                      <Button
                        variant="primary"
                        //type="submit"
                        onClick={() => {
                          onFormToggleSave();
                          setOnClickSave(true);
                        }}
                      >
                        Save
                      </Button>
                    </div>
                  </div>
                </div>
                <div className="slider-box">
                  {sliderLabel.map((item, index) => (
                    <div className="col-display">
                      <p className="headercontent">{item.label}</p>
                      <p className="valuecontent">
                        {/* {item.columnName == "vestingPercentage"
                          ? data[item.columnName] + "%" */}
                        {data[item.columnName]}
                      </p>
                    </div>
                  ))}
                </div>
                <div>
                  <div>
                    <p className="vesting-fieldlabel">Vested Balance</p>
                    <Field
                      size="xs"
                      isRequired
                      name={fields.vestedBalance}
                      value={values[fields.vestedBalance]}
                      onChange={handleChange}
                      component={FieldInputDecimal}
                      type="number"
                      autoComplete="off"
                      //disabled={values[fields.vestingOverride]}
                      min={0}
                      max={1000000000000000}
                    />
                  </div>
                  <div>
                    <p className="vesting-fieldlabel">Vesting override</p>
                    <Form.Check
                      type="switch"
                      autoFocus="off"
                      id={data.id}
                      name={fields.vestingOverride}
                      disabled={data?.vestingOverride}
                      checked={values[fields.vestingOverride]}
                      onChange={() => {
                        setFieldValue(
                          fields.vestingOverride,
                          !values[fields.vestingOverride]
                        );
                        clearValuesSlider();
                      }}
                    />
                  </div>
                  <div>
                    <p className="vesting-fieldlabel">Vesting YOS</p>
                    <Field
                      size="xs"
                      isRequired
                      name={fields.vestingYOS}
                      value={values[fields.vestingYOS]}
                      onChange={handleChange}
                      component={FieldInputNumber}
                      type="number"
                      autoComplete="off"
                      disabled={!values[fields.vestingOverride]}
                      min={0}
                      max={99}
                    />
                  </div>
                  {/* <div className="mt-20">
                    <p className="vesting-fieldlabel">Vesting Multiplier</p>
                    <Field
                      size="xs"
                      isRequired
                      name={fields.vestingMultiplier}
                      value={values[fields.vestingMultiplier]}
                      onChange={handleChange}
                      step="any" // used to remove the exclamatory suggestion in FieldInput
                      component={FieldInput}
                      type="number"
                      autoComplete="off"
                    />
                  </div> */}
                  <div>
                    <p className="vesting-fieldlabel">
                      Credited this computation period
                    </p>
                    <Field
                      size="sm"
                      name={fields.creditedThisYear}
                      options={yesNoOptions}
                      selectedValue={values[fields.creditedThisYear]}
                      type="text"
                      autoComplete="off"
                      value={values[fields.creditedThisYear]}
                      onChange={(value) => {
                        setValues({
                          ...values,
                          [fields.creditedThisYear]: value,
                        });
                      }}
                      isRequired
                      disabled={!values[fields.vestingOverride]}
                      component={FieldButtonGroup}
                    />
                  </div>
                  <div>
                    <p className="vesting-fieldlabel">Vesting Percentage</p>
                    <Field
                      size="xs"
                      isRequired
                      name={fields.vestingPercentage}
                      value={values[fields.vestingPercentage]}
                      onChange={handleChange}
                      component={FieldInputNumber}
                      type="number"
                      autoComplete="off"
                      disabled={!values[fields.vestingOverride]}
                      min={0}
                      max={100}
                    />
                  </div>
                  <div>
                    <Field
                      label="Comments"
                      name={fields.comments}
                      autoComplete="off"
                      value={values[fields.comments]}
                      placeholder="Enter Comments"
                      onChange={handleChange}
                      component={FieldTextarea}
                      size="lg"
                    />
                  </div>
                </div>
                <FormLeaveGuard
                  showModal={showDirtyCheckModal}
                  handleConfirmClick={handleConfirmClick}
                  handleCancelClick={handleCancelClick}
                />
                {onClickSave && (
                  <VestingOverrideToggle
                    showModal={showDirtyCheckModal}
                    handleConfirmClick={handleConfirmClickVar}
                    handleCancelClick={handleCancelClick}
                    sourceName={data.sourceName}
                  />
                )}
              </Form>
            );
          }}
        </Formik>
      </SliderPanel>

      <SliderPanel
        isOpen={historySliderOpen}
        size="70"
        showCancel={false}
        backdropClicked={() => setHistorySliderOpen(false)}
      >
        <LoaderWrapper isLoading={isLoading}>
          <div className="vesting-history-sliderpannel">
            <Formik
              initialValues={{
                ...initialValues,
              }}
              onSubmit={functionApiCall}
              enableReinitialize
              validateOnChange={false}
              validateOnBlur={false}
            >
              {({
                handleChange,
                setFieldValue,
                handleSubmit,
                setValues,
                values,
                ...rest
              }) => {
                const onDaySelected = (fieldName, value) => {
                  setFieldValue(fieldName, value);
                };
                return (
                  <Form autoComplete="off" onSubmit={handleSubmit}>
                    <div className="slider-header">
                      <div className="slider-sourcename">
                        Vesting history - {data.sourceName}
                      </div>
                      <div>
                        <Link
                          onClick={() => {
                            setHistorySliderOpen(false);
                          }}
                        >
                          <i class="fal fa-times slidercross-icon"></i>
                        </Link>
                      </div>
                    </div>
                    <div className="fl w-100 space-between">
                      <div
                        className="fl w-100 space-between center"
                        // style={{ marginBottom: "30px" }}
                      >
                        <div
                          className="fl center"
                          style={{ display: "flex", gap: "30px" }}
                        >
                          <div>
                            <Field
                              size="sm"
                              isRequired
                              label="Date range"
                              name={fields.fromDate}
                              value={usDateFormat(values[fields.fromDate])}
                              isDatePicker
                              placeholder="From date"
                              direction="rightSide"
                              onClear={() => onDaySelected(fields.fromDate, "")}
                              popupContent={
                                <DatePicker
                                  onDayClick={(value) =>
                                    onDaySelected(fields.fromDate, value)
                                  }
                                  value={values[fields.fromDate]}
                                />
                              }
                              component={FieldDropSide}
                            />
                          </div>
                          <div>
                            <Field
                              size="sm"
                              label=""
                              name={fields.toDate}
                              isRequired
                              placeholder="To date"
                              value={usDateFormat(values[fields.toDate])}
                              direction="rightSide"
                              isDatePicker
                              onClear={() => {
                                onDaySelected(fields.toDate, "");
                              }}
                              onDefaultClearDisplay={values[fields.fromDate]}
                              popupContent={
                                <DatePicker
                                  onDayClick={(value) =>
                                    onDaySelected(fields.toDate, value)
                                  }
                                  value={values[fields.toDate]}
                                />
                              }
                              component={FieldDropSide}
                            />
                          </div>
                          {/* <div className="ml-30">
                          <Field
                            size="smd"
                            isRequired
                            label="Label"
                            name={fields.label}
                            value={toMultiSelectValueById(
                              values[fields.label],
                              labelOptions
                            )}
                            options={labelOptions}
                            isMultiSelect
                            direction="vestingBottomSide"
                            popupContent={
                              <MultiSelectDropdown
                                label="Fields"
                                name={fields.label}
                                onSelect={(value) =>
                                  setFieldValue(fields.label, value)
                                }
                                value={values[fields.label]}
                                options={labelOptions}
                              />
                            }
                            component={FieldDropSide}
                          />
                        </div> */}
                          <Button
                            className="ml-30 mt-16"
                            // type="submit"
                            variant="secondary"
                            onClick={() => {
                              const fromdate = usDateFormat(
                                values[fields.fromDate]
                              );
                              const todate = usDateFormat(
                                values[fields.toDate]
                              );
                              filterByDates(fromdate, todate);
                            }}
                          >
                            Search
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Form>
                );
              }}
            </Formik>
            {/* <div className="mt-16  history-content">
            {
              // renderHistoryTimeline(sortedHistory, get(state,"firstName",""))
              employeeVestingHistoryDetails.length === 0 ? (
                <p>No data available</p>
              ) : (
                employeeVestingHistoryDetails.map((item) => {
                  return <EmployeeVestingHistoryTimeline data={item} />;
                })
              )
            }
          </div> */}
            <div className="overflow-scroll">
              {filteredData.map((item, index) => {
                return (
                  <div
                    // className="mt-3"
                    style={{
                      marginTop: "0.5rem",
                      position: "relative",
                      display: "inherit",
                      width: "100%",
                      //height: "100%",
                      overflowY: "scroll",
                      overflowX: "scroll",
                      marginLeft: "0 !important",
                      marginRight: "0 !important",
                    }}
                  >
                    <div className="mb-2 font-weight-bold">
                      Run Date :{" "}
                      {item[0].runDate.replace("T", " ").replace("Z", "")}
                    </div>
                    <Grid
                      data={item}
                      //data={Object.keys(item)}
                      // style={{ height: "400px" }}
                      // total={forfeitureTable.length}
                      onScroll={scrollHandler}
                      resizable={true}
                      fixedScroll
                    >
                      {final.map((column, idx) => {
                        return (
                          <GridColumn
                            key={idx}
                            title={column.label}
                            field={column.field}
                            filter={column.dataType}
                            width={column.width}
                            cell={
                              column.field === "runDate" ||
                              column.field === "startDate" ||
                              column.field === "endDate"
                                ? renderValueDate
                                : column.field === "creditedThisYear" ||
                                  column.field === "vestingOverride"
                                ? renderValueBoolean
                                : column.field === "computationPeriod"
                                ? renderValueDateRange
                                : renderValue
                            }
                            headerCell={ProductNameHeader}
                            columnMenu={
                              false
                              // (props) => (
                              // !isEmpty(tempVestingHistoryDetails) ||
                              // (gridFilters &&
                              //   (gridFilters[column.field1] ||
                              //     (column.field2 &&
                              //       gridFilters[column.field2]))) ? (
                              // <ColumnMenu
                              //   {...props}
                              //   fields={fields}
                              //   sorting={sorting}
                              //   setSorting={setSorting}
                              //   //gridFilters={gridFilters}
                              //   //setGridFilters={setGridFilters}
                              //   field1={column.field1}
                              //   field2={column.field2 ? column.field2 : null}
                              //   columns={selectedColumns}
                              // />
                              // )
                              // ) : null
                            }
                          />
                        );
                      })}
                    </Grid>
                  </div>
                );
              })}
            </div>
          </div>
        </LoaderWrapper>
      </SliderPanel>
    </>
  );
};

export default CensusVestingCard;
